export default __webpack_public_path__ + "static/media/Akriti_Sinha_Social_media_lead.566c8dd7.jpg";